import { getBuildInfo, formatTaiwanTime } from '@/version';

export function Footer() {
  const buildInfo = getBuildInfo();
  const taiwanTime = formatTaiwanTime(buildInfo.buildTime);

  return (
    <footer className="mt-16 py-8 border-t border-[#e2e8f0] bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm">

          {/* 版本資訊 */}
          <div className="flex items-center gap-4">
            <span className="text-xs font-medium text-[#64748b] uppercase">
              Version
            </span>
            <span className="px-3 py-1 bg-[#0066cc]/10 text-[#0066cc] rounded text-xs font-semibold border border-[#0066cc]/20">
              v{buildInfo.version}
            </span>
            {buildInfo.commitHash && (
              <span className="text-xs text-[#64748b] font-mono bg-[#f8fafc] px-2 py-1 rounded border border-[#e2e8f0]">
                {buildInfo.commitHash.slice(0, 7)}
              </span>
            )}
          </div>

          {/* 建置時間 */}
          <div className="flex items-center gap-2">
            <span className="text-xs text-[#64748b]">更新時間</span>
            <span className="text-xs text-[#475569] bg-[#f8fafc] px-3 py-1.5 rounded border border-[#e2e8f0]">
              {taiwanTime}
            </span>
          </div>
        </div>

        {/* 版權資訊 */}
        <div className="mt-6 pt-6 border-t border-[#e2e8f0]/50 text-center">
          <p className="text-xs text-[#64748b]">
            製造排程系統 POC Demo © 2026
          </p>
        </div>
      </div>
    </footer>
  );
}
